import { map, filter } from 'rxjs/operators';
import { ofType } from 'redux-observable';
// ---- external imports -----

import { uiActions } from '~/store';
import { GAME_UPDATE_CASH, GAME_LOADED_ENDED } from '~/store/game/actionTypes';
import { PLAYER_HEALTH_UPDATED } from '~/store/playerHealth/actionTypes';
import { MAIN_SCREEN_MODALS } from '~/lib/constants';
// ---- internal imports ----


const onGameOverEpic = (action$) => action$.pipe(
	ofType(
		GAME_UPDATE_CASH,
		PLAYER_HEALTH_UPDATED,
		GAME_LOADED_ENDED
	),
	map((action) => {
		let isGameOver = false;

		if (action.type === GAME_LOADED_ENDED) {
			isGameOver = action.cash < 0 || action.playerHealth <= 0;
		}

		if (action.type === GAME_UPDATE_CASH) {
			isGameOver = action.updatedCash < 0 ? true : false;
		}

		if (action.type === PLAYER_HEALTH_UPDATED ) {
			isGameOver = action.playerHealth <= 0;
		}

		if (isGameOver) {
			return uiActions.changeActiveModal(MAIN_SCREEN_MODALS.GAME_OVER);
		}
	}),
	filter(Boolean)
);


export default onGameOverEpic;
